import { FormBlankSpace } from './FormBlankSpace'

export const FormBlankSpacePrint = (props) => {
  return <FormBlankSpace {...props} />
}
